module.exports = __webpack_public_path__ + "img/ef-logo-mob.ccdcf25c.svg";